import { makeStyles } from "@mui/styles";
import { alpha, Theme } from "@mui/material";

export default makeStyles<Theme>(({ palette }) => ({
  addIconRoot: {
    color: alpha(palette.common.black, 0.5),
  },
}));
